/**
 * Shared legal copy (Danish) for Terms & Conditions and Privacy Policy pages.
 * Used verbatim by all brands until per-brand translations are provided —
 * a brand can swap in its own data file and pass it to <LegalPage />.
 */

export const TERMS_TITLE = 'Handelsvilkår';

export const TERMS_SECTIONS = [
  {
    blocks: [
      {
        type: 'p',
        text: 'Bestilling foretages via C.L. Seifert Danmark A/S’ webshop. Når kunden afgiver sin ordre og gennemfører betaling accepteres det samtidig, at C.L. Seifert med det samme kan påbegynde fremstilling af varerne (betalingen hæves således umiddelbart efter bestillingens gennemførelse). Når betalingen er gennemført, ses en kvittering i internetbrowseren. Samtidig afsendes en ordrebekræftelse til den af kunden oplyste e-mailadresse.',
      },
    ],
  },
  {
    title: 'Priser',
    blocks: [
      {
        type: 'p',
        text: 'Alle priser er angivet i danske kroner, inkl. moms. Priserne for de enkelte varer tillægges et ekspeditions- og fragtgebyr på kr. 39. Du vil altid kunne se den samlede pris, inkl. ekspeditions- og fragtgebyr, i forbindelse med gennemførelsen af din ordre.',
      },
    ],
  },
  {
    title: 'Betaling',
    blocks: [
      {
        type: 'p',
        text: 'Betaling af varer bestilt i C.L. Seiferts webshop kan alene ske online samtidig med bestilling. Der kan betales med: Dankort, VISA/Dankort, VISA Electron, VISA(DK), Maestro(DK), Eurocard/Mastercard(DK). Der opkræves et betalingsgebyr svarende til gebyret, der opkræves af PBS (Kortbetalinger). Alle betalinger håndteres af EPay A/S via en krypteret side med SSL (Secure Socket Layer). C.L. Seifert hverken håndterer eller lagrer kortinformationer.',
      },
    ],
  },
  {
    title: 'Generelt',
    blocks: [
      {
        type: 'p',
        text: 'Der tages forbehold for force majeure, udsolgte varer, tastefejl samt forsinkelser hos transportleverandører. For varer, hvor kunden kan bestille et “personligt præg” på varen, som f.eks. navnetryk, forbeholder C.L. Seifert sig ret til ikke at fremstille varen efter kundens ønske, såfremt dette “personlige præg” kan virke stødende på andre. Priserne er kun gældende til levering i Danmark eksklusive Færøerne og Grønland.',
      },
    ],
  },
  {
    title: 'Levering',
    blocks: [
      {
        type: 'p',
        text: 'Alle varer sendes med GLS til gymnasiets adresse. Klassens trøjerepræsentant, kan I tilsendt kontrakt se aftalt leveringsdag, (typisk en måned før afrejse).',
      },
    ],
  },
  {
    title: 'Reklamationer',
    blocks: [
      {
        type: 'p',
        text: 'Når du handler på clothing.clseifert.com finder købelovens mangelsregler anvendelse (d.v.s 24 måneders reklamationsret). Hvis du mener, at din vare har en fejl eller en mangel, skal du kontakte vores kundeservice. Når du henvender dig, skal du forklare, hvad fejlen eller manglen ved varen er. Du skal kontakte os hurtigst muligt og inden for rimelig tid efter, at du er blevet opmærksom på fejlen eller manglen. Vi vil altid forsøge at løse reklamationer hurtigst muligt, men da der er en vis produktionstid på visse varer, er det vigtigt, at du reklamerer så hurtigt som muligt.',
      },
    ],
  },
  {
    title: 'Returnering af varer (Fortrydelsesret)',
    blocks: [
      {
        type: 'p',
        text: 'Specialfremstillede varer, som f.eks. studieturstrøjer med tryk, kan ikke returneres. Ved afgivelse af ordrer på disse varer accepteres det, at fremstilling påbegyndes med det samme.',
      },
      {
        type: 'p',
        text: 'Disse vilkår og betingelser er underlagt dansk lov.',
      },
    ],
  },
];

export const PRIVACY_TITLE = 'Privatlivspolitik';

export const PRIVACY_SECTIONS = [
  {
    title: 'Cookies',
    blocks: [
      {
        type: 'p',
        text: 'Dette website anvender cookies, for at bidrage til at give dig den bedste oplevelse, vi kan. Cookies er små tekstfiler, der placeres på din computer eller mobiltelefon, når du besøger websites.',
      },
    ],
  },
  {
    title: 'Vi anvender cookies til følgende formål',
    blocks: [
      {
        type: 'ul',
        items: [
          'Forbedre din brugeroplevelse og få avancerede funktioner til at virke',
          'Forbedre hastigheden/sikkerheden for webstedet',
          'Tillade dig at dele sider med sociale netværk som Facebook o.a.',
          'Løbende forbedre vores hjemmeside til fordel for dig',
          'Teknisk funktionalitet, så vi kan huske dine præferencer',
          'Trafikmåling, så vi ved hvor mange, der besøger vores site og kan dokumentere dette',
          'Annonceafvikling, så vi kan styre, hvor ofte samme annonce vises til den samme bruger og registrere hvor mange, der klikker på den.',
          'Adfærdsbaseret individuelt målrettet annoncering, så vi kan vise dig de annoncer, som vi formoder, er mest relevante for dig.',
        ],
      },
    ],
  },
  {
    title: 'Vi anvender ikke cookies til',
    blocks: [
      {
        type: 'ul',
        items: [
          'At indsamle personligt identificerbare oplysninger (uden din udtrykkelige tilladelse)',
          'At samle følsomme oplysninger (uden din udtrykkelige tilladelse)',
          'At videregive personligt identificerbar data til tredjepart',
        ],
      },
    ],
  },
  {
    title: 'Oversigt',
    blocks: [
      {
        type: 'ul',
        items: [
          'Ejeroplysninger',
          'Hvad er Cookies?',
          'Så lang tid opbevares cookies',
          'Sådan sletter du cookies',
          'Sådan undgår du cookies',
          'Hvad cookies bruges til på vores website',
          'Brug af personoplysninger',
          'Kontakt vedr. personoplysninger',
          'Beskyttelse af personoplysninger',
        ],
      },
    ],
  },
  {
    title: '1. Ejeroplysninger',
    blocks: [
      { type: 'p', text: 'Dette website udbydes af:' },
      {
        type: 'lines',
        lines: [
          'C.L. SEIFERT Danmark A/S',
          'NY ADELGADE 8-10',
          '1104 KØBENHAVN K',
          'TLF: +45 33 12 02 77',
          'INFO@CLSEIFERT.DK',
          'CVR: 38890980',
        ],
      },
    ],
  },
  {
    title: '2. Cookies',
    blocks: [
      {
        type: 'p',
        text: 'Dette website anvender cookies i henhold til ovenstående formål. En cookie er en lille tekstfil, der lagres i din browser og for at kunne genkende din computer ved tilbagevendende besøg. Der er ingen personlige oplysninger gemt i vores cookies og de kan ikke indeholde virus.',
      },
    ],
  },
  {
    title: '2.1 Så lang tid opbevares cookies',
    blocks: [
      {
        type: 'p',
        text: 'Cookies sletter sig selv efter et vist antal måneder (kan variere), men de fornyes efter hvert besøg på vores website.',
      },
    ],
  },
  {
    title: '2.2 Sådan sletter du cookies',
    blocks: [
      { type: 'p', text: 'Se vejledning her: http://www.minecookies.org/cookiehandtering' },
    ],
  },
  {
    title: '2.3 Sådan undgår du cookies?',
    blocks: [
      { type: 'p', text: 'Hvis du ikke ønsker at modtage cookies kan du blokere dem.' },
      { type: 'p', text: 'Se vejledning her: http://www.minecookies.org/cookiehandtering' },
    ],
  },
  {
    title: '2.4 Hvad cookies bruges til på vores website',
    blocks: [
      {
        type: 'p',
        text: 'Cookies anvendes til at føre statistik over antallet af brugere samt oplysninger om køn, alder, geografi og interesser på vores brugere for at tilpasse indhold og annoncering herefter.',
      },
      {
        type: 'p',
        text: 'Sitet anvender cookies fra en eller flere af følgende parter og tredjeparter, der har adgang til de pågældende cookies:',
      },
      { type: 'h4', text: 'Vores egne cookies' },
      {
        type: 'p',
        text: 'Vi anvender cookies til at få vores website til at fungere korrekt. Det sker f.eks. hvis der tilbydes personaliseringsvalg på websitet, validering af data såsom telefonnummer, betalingsløsninger, samt avanceret funktionalitet såsom afstemninger, produktbedømmelser mm.',
      },
      { type: 'h4', text: 'Tredjeparts cookies' },
      {
        type: 'p',
        text: 'Vores website omfatter funktionalitet der leveres af tredjepart. Et almindeligt eksempel er en indbygget YouTube video. Vores website indeholder en eller flere af følgende, som anvender cookies:',
      },
      {
        type: 'ul',
        items: ['Google Analytics', 'Snap Engage', 'Add This', 'Share This', 'Med flere'],
      },
      {
        type: 'p',
        text: 'Deaktivering af disse cookies vil sandsynligvis afbryde de funktioner, der tilbydes af disse tredjeparter',
      },
      { type: 'h4', text: 'Cookies til forbedring af websitet' },
      {
        type: 'p',
        text: 'Vi afprøver jævnligt nye designs eller funktioner på vores website. Vi gør dette ved at vise forskellige versioner af vores hjemmeside for forskellige besøgende og anonymt analysere, hvordan vores besøgende reagerer på disse forskellige versioner. I sidste ende hjælper det os til at tilbyde dig et bedre website.',
      },
      { type: 'h4', text: 'Cookies til anonym besøgsstatistik' },
      {
        type: 'p',
        text: 'Vi bruger cookies til at udarbejde besøgsstatistik, som viser hvor mange mennesker, der har besøgt vores website, hvilken type teknologi de bruger (f.eks. Mac eller Windows, hvilket hjælper os med at identificere, om vores website ikke fungerer som det skal for særlige teknologier), hvor lang tid de bruger på sitet, hvilken side de ser på osv. Dette hjælper os med at forbedre vores hjemmeside. Disse såkaldte analyseprogrammer fortæller os også, på et anonymt grundlag, hvordan folk kom frem til dette site (f.eks. fra en søgemaskine), og om de har været her før.',
      },
      { type: 'h4', text: 'Cookies til annoncering' },
      {
        type: 'p',
        text: 'Cookies er meget udbredt inden for online-annoncering. Hverken vi, vore annoncører eller vores reklamepartnere får personligt identificerbare oplysninger fra disse cookies.',
      },
      {
        type: 'p',
        text: 'Du kan lære mere om online-annoncering på http://www.minecookies.org/cookiehandtering Du kan fravælge næsten alle reklamecookies på http://www.minecookies.org/fravalg selv om vi ville foretrække, at du ikke gjorde det. I sidste ende hjælper reklamer med at holde meget af internettet gratis. Det er også værd at bemærke, at fravalg af reklamecookies ikke vil betyde, at du ikke vil se reklamer, blot, at de ikke vil blive skræddersyet til dig længere.',
      },
      { type: 'h4', text: 'Cookies til remarketing' },
      {
        type: 'p',
        text: 'Du har måske bemærket, at nogle gange efter at have besøgt et websted, ser du et øget antal reklamer fra det websted, du netop har besøgt. Teknologien til at gøre dette, er gjort mulig ved hjælp af cookies. Vi placerer til tider en såkaldt ”remarketing cookie” under dit besøg. Vi bruger disse reklamer til at vise specielle tilbud og til at opfordre dig til at komme tilbage til vores site. Du kan fravælge disse cookies når som helst som forklaret ovenfor.',
      },
    ],
  },
  {
    title: '3. Brug af personoplysninger',
    blocks: [
      {
        type: 'p',
        text: 'Personoplysninger afgives aldrig til tredjepart, med mindre du selv udtrykkeligt giver tilsagn hertil, og vi indsamler aldrig personoplysninger, uden at du selv har givet os disse oplysninger ved registrering, køb eller deltagelse i en undersøgelse m.v. Her indsamles oplysninger om navn, adresse, postnummer, e-mail, køn, alder, interesser, holdninger og kendskab til forskellige emner.',
      },
      {
        type: 'p',
        text: 'Personoplysninger bruges til at gennemføre det køb eller den service, som oplysningerne er indsamlet i forbindelse med. Oplysningerne bruges derudover til at få større kendskab til dig og øvrige brugere af websitet. Denne brug kan bl.a. omfatte undersøgelser og analyser, der er rettet mod en forbedring af vore produkter, tjenester og teknologier, samt visning af indhold og reklamer, der er tilpasset dine interesser og hobbyer.',
      },
    ],
  },
  {
    title: '3.1 Kontakt vedr. personoplysninger',
    blocks: [
      {
        type: 'p',
        text: 'Hvis du ønsker adgang til de oplysninger, som er registreret om dig hos C.L. Seifert A/S, skal du rette henvendelse på info@clseifert.dk.dk eller telefon +45 33 12 02 77 Er der registreret forkerte data, eller har du andre indsigelser, kan du rette henvendelse samme sted. Du har mulighed for at få indsigt i, hvilke informationer der er registreret om dig, og du kan gøre indsigelse mod en registrering i henhold til reglerne i Persondataloven.',
      },
    ],
  },
  {
    title: '3.2 Beskyttelse af personoplysninger',
    blocks: [
      {
        type: 'p',
        text: 'Ifølge persondataloven skal dine personlige oplysninger opbevares sikkert og fortroligt. Vi gemmer dine personlige oplysninger på computere med begrænset adgang, som er placeret i kontrollerede faciliteter, og vores sikkerhedsforanstaltninger kontrolleres løbende for at afgøre, om vores brugeroplysninger håndteres forsvarligt, og under stadig hensyntagen til dine rettigheder som bruger. Vi kan dog ikke garantere 100 procent sikkerhed ved dataoverførsler via internettet. Det betyder, at der kan være en risiko for, at andre uberettiget tiltvinger sig adgang til oplysninger, når data sendes og opbevares elektronisk. Du afgiver således dine personlige oplysninger på eget ansvar.',
      },
      {
        type: 'p',
        text: 'Personoplysninger slettes eller anonymiseres løbende efterhånden som det formål, de blev indsamlet til, afsluttes. Personoplysninger gemmes højst i 12 måneder efter brug.',
      },
      {
        type: 'p',
        text: 'Ved bestilling af skoletrøjer vil ens navn optræde på en elevliste. Så klasserepræsentanten kan få et overblik over, hvem der har bestilt i klassen. Navnet slettes efter ordren er leveret.',
      },
      {
        type: 'p',
        text: 'Den hurtige udvikling af internettet betyder, at ændringer i vores behandling af personoplysninger kan blive nødvendige. Vi forbeholder os derfor ret til at opdatere og ændre nærværende retningslinjer for behandling af personoplysninger. I tilfælde af væsentlige ændringer giver vi dig besked i form af en synlig meddelelse på vores websites.',
      },
      {
        type: 'p',
        text: 'I det omfang, der behandles personoplysninger om dig, har du ifølge persondataloven ret til at få oplyst, hvilke personoplysninger, der kan henføres til dig. Såfremt det viser sig, at de oplysninger eller data, der behandles om dig, er urigtige eller vildledende, har du ret til at kræve disse berigtiget, slettet eller blokeret. Du kan til enhver tid gøre indsigelse mod, at oplysninger om dig gøres til genstand for behandling. Du kan også til enhver tid tilbagekalde dit samtykke. Du har mulighed for at klage over behandlingen af oplysninger og data vedrørende dig. Klage indgives til Datatilsynet, jf. persondatalovens § 58, stk. 1.',
      },
      {
        type: 'p',
        text: 'Forretningen vil ikke afsløre information om kunder/brugere til tredje part, med mindre det er nødvendigt for at implementere en transaktion. Forretningen vil ikke sælge dit navn, adresse, e-mail adresse, kreditkort eller personlige data til nogen tredjepart uden din forudgående tilladelse.',
      },
    ],
  },
  {
    title: 'Spambeskyttelse (CAPTCHA)',
    blocks: [
      {
        type: 'p',
        text: 'For at beskytte vores formularer (f.eks. kontaktformularen) mod spam og misbrug anvender vi Cloudflare Turnstile. Når Turnstile kører i usynlig tilstand, behandler Cloudflare visse tekniske oplysninger om din enhed og browser. Læs mere i Cloudflares Turnstile-privatlivstillæg: https://www.cloudflare.com/en-gb/turnstile-privacy-policy/',
      },
    ],
  },
  {
    title: 'AI-assistent i vores administration (Anthropic)',
    blocks: [
      {
        type: 'p',
        text: 'Vores medarbejdere kan bruge en AI-assistent i vores interne administrationssystem, f.eks. når de besvarer spørgsmål om ordrer, produkter og skoleshops. Assistenten leveres af Anthropic (Claude). Når en medarbejder stiller assistenten et spørgsmål, der kræver det, kan oplysninger fra din ordre blive sendt til Anthropic: navn, kontaktoplysninger, leveringsadresse, skole og klasse samt ordrens indhold, betalings- og leveringsstatus. Assistenten har kun adgang til de oplysninger, som den pågældende medarbejder selv har adgang til.',
      },
      {
        type: 'p',
        text: 'Anthropic behandler oplysningerne som databehandler på vores vegne og må ikke bruge dem til egne formål, herunder til at træne AI-modeller. Oplysningerne behandles i USA; overførslen sker på grundlag af EU-Kommissionens standardkontraktbestemmelser i vores databehandleraftale med Anthropic. Behandlingen sker på grundlag af vores legitime interesse i at kunne yde hurtig og korrekt kundeservice og administration (databeskyttelsesforordningens artikel 6, stk. 1, litra f). Læs mere i Anthropics privatlivspolitik: https://www.anthropic.com/legal/privacy',
      },
    ],
  },
];
